import React, { useCallback, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ResetPassword from "./pages/ResetPassword";
import Subscription from "./pages/Subscription";
import ChatApp from "./pages/ChatApp";
import WhatsAppExistingOAuthCallback from "./pages/WhatsAppExistingOAuthCallback";
import { useAuth } from "./context/AuthContext";
import { Session } from "./storage/session";
// import { useSocket } from "./hooks/useSocket";
import "./App.css";
import "./styles/app.css";

/** Login payload may include decodedToken; otherwise read WhatsAppCloud from JWT. */
function whatsAppCloudFromLoginData(data) {
  const fromPayload = data?.decodedToken?.UserProfile?.WhatsAppCloud;
  if (fromPayload !== undefined) return fromPayload;
  try {
    return jwtDecode(data.token)?.UserProfile?.WhatsAppCloud;
  } catch {
    return undefined;
  }
}

function needsWhatsAppCloudSetup(wc) {
  if (wc == null || wc === "") return true;
  if (typeof wc === "object" && !Array.isArray(wc))
    return Object.keys(wc).length === 0;
  return false;
}

export default function App() {
  const { logout: authLogout } = useAuth();
  const [stage, setStage] = useState(() =>
    Session.get() ? "chat" : "login"
  );
  /** After login: open Configuration modal (same as gear) instead of full-screen Config. */
  const [openConfigModalOnce, setOpenConfigModalOnce] = useState(false);

  const handleOpenConfigModalConsumed = useCallback(() => {
    setOpenConfigModalOnce(false);
  }, []);

  // WebSocket Integration at Global Level
  const { token, decodeToken } = useAuth();

  // Extract user info for socket
  let userProfile = null;
  try {
    if (token) {
      const decoded = decodeToken(token);
      userProfile = decoded?.UserProfile || null;
    }
  } catch {
    userProfile = null;
  }

  const userId = userProfile?.PK || userProfile?.Mobile;
  const phoneId = userProfile?.phoneNumberId;

  // const { lastMessage } = useSocket(userId, phoneId, stage === "chat" && !!token);

  if (stage === "login") {
    return (
      <Routes>
        <Route path="/register" element={<Register />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/subscription" element={<Subscription />} />
        <Route
          path="/login"
          element={
            <Login
              onZibuzzSessionReady={(data) => {
                Session.save({
                  ...data,
                  status: "success",
                  token: data.token,
                });
                const wc = whatsAppCloudFromLoginData(data);
                setOpenConfigModalOnce(needsWhatsAppCloudSetup(wc));
                setStage("chat");
              }}
            />
          }
        />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        path="metaCallback"
        element={<WhatsAppExistingOAuthCallback />}
      />
      <Route
        path="*"
        element={
          <ChatApp
            openConfigModalOnce={openConfigModalOnce}
            onOpenConfigModalConsumed={handleOpenConfigModalConsumed}
            onLogout={() => {
              setStage("login");
              authLogout();
            }}
            userId={userId}
            phoneId={phoneId}
          // lastSocketMessage={lastMessage}
          />
        }
      />
    </Routes>
  );
}
